import {useState, useEffect, useRef} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {toast} from 'react-toastify'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import '../Assessment/style.css'
import {useNavigate, useParams} from 'react-router-dom'

import AlertModal from '../Assessment/AlertModal'
import Member from '../Assessment/Member'
import ProfilePana from '../Assessment/ProfilePana'
import Note from '../Assessment/Note'
import History from '../Assessment/History'
import TypeProposal from '../Assessment/TypeProposal'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
import BackButton from '../Monitoring/BackButton'
import ProposalSummary from '../Assessment/ProposalSummary'

const api = new Api()

const DetailPage = () => {
  let navigate = useNavigate()
  const {id} = useParams()

  const [fieldRefs, setFieldRefs] = useState<any>({
    nilai: useRef(null),

    catatan_dokumen_kerja: useRef(null),
    catatan_dokumen_kesehatan: useRef(null),
    catatan_dokumen_komitmen: useRef(null),
    catatan_dokumen_ppt: useRef(null),
    catatan_dokumen_proposal: useRef(null),

    dokumen_ppt: useRef(null),
    dokumen_proposal: useRef(null),
    dokumen_kerja: useRef(null),
    dokumen_kesehatan: useRef(null),
    dokumen_komitmen: useRef(null),
  })

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>([])

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false)
  const [formValue, setFormValue] = useState<any>({})
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (id) {
      fetchDetail(id)
      return
    }
  }, [])

  useEffect(() => {
    if (!errors) {
      return
    }

    scrollToElement(errors)
  }, [errors])

  const handleCloseAlertModal = (action: boolean, isOk: boolean) => {
    setShowAlertModal(action)

    if (isOk) {
      handleSave()
    }
  }

  const scrollToElement = (errors: any) => {
    const firstErrorField = Object.keys(errors)[0]
    const target = fieldRefs[firstErrorField]

    if (target && target.current) {
      const yOffset = -80 // jika ada header
      const y = target.current.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({top: y, behavior: 'smooth'})
    }
  }

  const fetchDetail = (id: any) => {
    setLoading(true)
    api
      .getDetailVerif(id)
      .then((response: any) => {
        const {data} = response.data
        setData(data)

        setFormValue({
          ...formValue,
          assignment_id: id,
          catatan_penilaian: data?.penilaian?.catatan_penilaian,
          dokumen_ppt: data?.penilaian?.dokumen_ppt,
          dokumen_proposal: data?.penilaian?.dokumen_proposal,

          dokumen_surat_kerja: data?.penilaian?.dokumen_surat_kerja,
          dokumen_surat_kesehatan: data?.penilaian?.dokumen_surat_kesehatan,
          dokumen_surat_komitmen: data?.penilaian?.dokumen_surat_komitmen,

          catatan_dokumen_ppt: data?.penilaian?.catatan_dokumen_ppt,
          catatan_dokumen_proposal: data?.penilaian?.catatan_dokumen_proposal,
          catatan_dokumen_surat_kerja: data?.penilaian?.catatan_dokumen_kerja,
          catatan_dokumen_surat_kesehatan: data?.penilaian?.catatan_dokumen_kesehatan,
          catatan_dokumen_surat_komitmen: data?.penilaian?.catatan_dokumen_komitmen,
        })
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        setErrors(data?.meta?.error)
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const handleInput = (name: any, value: any) => {
    setFormValue({...formValue, [name]: value})
  }

  const handleSave = () => {
    setLoading(true)

    formValue['catatan_dokumen_kerja'] = formValue?.catatan_dokumen_surat_kerja
    formValue['catatan_dokumen_kesehatan'] = formValue?.catatan_dokumen_surat_kesehatan
    formValue['catatan_dokumen_komitmen'] = formValue?.catatan_dokumen_surat_komitmen

    api
      .saveAssessmentVerificator(formValue)
      .then((response: any) => {
        const {data, status} = response.data
        setLoading(false)
        navigate('/dashboard')
        toast.success(data?.message ?? data?.meta?.message ?? 'Berhasil simpan data')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        toast.error(data?.message ?? data?.meta?.message)
        setErrors(data?.meta?.error ?? data?.errors)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  return (
    <>
      <AlertModal showModal={showAlertModal} handleShowModalAlert={handleCloseAlertModal} />

      <div className='row'>
        <div className='col-md-12'>
          <BackButton to='/dashboard' />
        </div>

        <div className='col-md-12 px-6 mt-8'>
          <ProfilePana data={data?.pendaftaran} />
        </div>

        <div className='col-md-12 mt-8'>
          <Member data={data?.pendaftaran} allowEdit={false} reloadData={{}} />
        </div>

        <div className='col-md-12 mt-8'>
          <div className='card'>
            <div className='px-8 py-7'>
              <div className='d-flex align-items-center gap-3'>
                <p className='fs-4 fw-bold'>Tema Essay Utama</p>
              </div>
            </div>
            <div className='px-8 pb-8'>
              <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
                <p className='mb-0'>Tema Essay</p>
              </div>
              <div className='p-5 border'>
                <p className='mb-0'>{data?.pendaftaran?.judul_proposal || '-'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12 mt-8'>
          <ProposalSummary
            title='Ringkasan Proposal Utama'
            value={data?.pendaftaran?.ringkasan_proposal}
          />
        </div>

        {data?.pendaftaran?.anggota?.length > 0 && (
          <>
            <div className='col-md-12 mt-8'>
              <div className='card'>
                <div className='px-8 py-7'>
                  <div className='d-flex align-items-center gap-3'>
                    <p className='fs-4 fw-bold'>Tema Essay Kedua</p>
                  </div>
                </div>
                <div className='px-8 pb-8'>
                  <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
                    <p className='mb-0'>Tema Essay</p>
                  </div>
                  <div className='p-5 border'>
                    <p className='mb-0'>{data?.pendaftaran?.judul_proposal_2 || '-'}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-12 mt-8'>
              <ProposalSummary
                title='Ringkasan Proposal Kedua'
                value={data?.pendaftaran?.ringkasan_proposal_2}
              />
            </div>
          </>
        )}

        <div className='col-md-12 mt-8'>
          <TypeProposal
            radioButton={true}
            title='Jenis Penilaian Dokumen'
            data={formValue}
            handleInput={handleInput}
            dataFile={data}
            isAdmin={false}
            errors={errors}
            fieldRefs={fieldRefs}
          />
        </div>

        <div className='col-md-12 mt-8'>
          <Note
            name='catatan_penilaian'
            title='Catatan Penilaian'
            handleInput={handleInput}
            defaultValue={formValue?.catatan_penilaian}
            readOnly={false}
            defaultDataNote={[]}
            errors={errors}
          />
        </div>

        {/* <div className='col-md-12 mt-8'>
          <History />
        </div> */}

        <div className='col-md-12 mt-8'>
          <div className='card'>
            <div className='px-7'>
              <hr className='dashed-line mt-6' />

              <button
                className='btn btn-primary btn-sm w-100 mt-3'
                style={{background: 'var(--Primary-L-500, #F95E2F)'}}
                disabled={loading}
                onClick={() => setShowAlertModal(true)}
              >
                {loading ? 'Loading...' : 'Simpan'}
              </button>

              <button
                className='btn btn-sm w-100 mt-3 mb-3 text-primary'
                onClick={() => navigate('/dashboard')}
                disabled={loading}
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Detail = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'PANA',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Jenis Penilaian
      </PageTitle>
      <DetailPage />
    </>
  )
}

export default Detail
